import type { CoviThreadMeta } from "../model/types"

/**
 * Sections for the thread list, in the order they are shown: pinned threads,
 * then everything else. Only the pinned section is labelled, and even that
 * label is the panel surfaces' — the sidebar draws no section headings at all
 * (see `CoviThreadList`), where the pin and chat icons on the rows themselves
 * say which section a chat is in. Empty sections are omitted, so every label a
 * user sees describes rows that are actually there.
 */

/** Not exported — callers use the inferred shape of the grouping function. */
interface CoviThreadGroup {
  /** Stable key; unlike the label it is always present. */
  id: string
  /** Heading text, or null for a section that reads without one. */
  label: string | null
  threads: CoviThreadMeta[]
}

/** Group threads newest-first, pinned ones lifted into their own top section. */
export function groupThreads(threads: CoviThreadMeta[]): CoviThreadGroup[] {
  const sorted = [...threads].sort((a, b) => b.updatedAt - a.updatedAt)
  const pinned = sorted.filter((thread) => thread.pinned)
  const recent = sorted.filter((thread) => !thread.pinned)

  const groups: CoviThreadGroup[] = []
  if (pinned.length > 0) {
    groups.push({ id: "pinned", label: "Pinned", threads: pinned })
  }
  if (recent.length > 0) {
    groups.push({ id: "recent", label: null, threads: recent })
  }
  return groups
}
